import React, {useState} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import RadioLabel from '../../../typography/Input/RadioLabel'
import ReactTooltip from 'react-tooltip'
import {getCloningFlags, getTooltipMessage} from '../../../mycourses/util'

const InputContainer = styled.form`
  position: relative;
`
const InputOption = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  max-width: fit-content;
`
const Input = styled.input`
  margin-right: 1rem;
`

export const RadioInputComponent = ({ onChange, journey, disableCloning, orgFlags }) => {
  const [selectedValue, setSelectedValue] = useState('new')
  const handleChangeSelectedValue = (e) => {
    setSelectedValue(e.target.value)
    onChange(e.target.value)
  }

  const message = getTooltipMessage(orgFlags, journey)

  return (
    <InputContainer onChange={handleChangeSelectedValue}>
      <InputOption>
        <Input type="radio" id="new" name="new" value="new" onChange={handleChangeSelectedValue} checked={selectedValue === 'new'}/>
        <RadioLabel htmlFor="new">Create a new {journey ? 'journey' : 'course'} from scratch.</RadioLabel>
      </InputOption>
      <InputOption data-for="no-course-tooltip" data-tip={message}>
        <Input disabled={disableCloning} type="radio" id="existing" name="existing" value="existing" onChange={handleChangeSelectedValue} checked={selectedValue === 'existing'}/>
        <RadioLabel disabled={disableCloning} htmlFor="existing">Start with an existing {journey ? 'journey' : 'course'}.</RadioLabel>
      </InputOption>
      {disableCloning && <ReactTooltip
        id="no-course-tooltip"
        place="top"
        effect="solid"
        className="activityCourseTooltip"
      />}
    </InputContainer>
  )
}

RadioInputComponent.defaultProps = {
  onChange: () => {},
  journey: false
}

RadioInputComponent.propTypes = {
  onChange: PropTypes.func
}

export default RadioInputComponent



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/RadioInputComponent.js